import { IDeleteAreaChecklistServicosUseCase } from "../../../presentation/useCases/delete/delete_area_checklist_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteAreaChecklistServicosUseCase
 */

export class DeleteAreaChecklistServicosUseCase implements IDeleteAreaChecklistServicosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteAreaChecklistServicos(
    areas: number[] | undefined,
    checklists: number[] | undefined,
  ): Promise<void> {
    await this.repository.deleteAreaChecklistServicos(
      areas ?? [],
      checklists ?? [],
    );
  }
}
